export var sdkVersion = '25.8';
export var environmentPrefix = 'LOOKERSDK';
//# sourceMappingURL=constants.js.map